module.exports = angular.module('filters.rrCamelToTitleCase', []).filter('rrCamelToTitleCase', function () {
    var camelCaseToTitleCase = function (text) {
        if (!text)
            return text;
        var result = text.replace(/([A-Z])/g, " $1");
        var finalResult = result.charAt(0).toUpperCase() + result.slice(1);
        return finalResult;
    };

    return function (input) {
        return camelCaseToTitleCase(input);
    };
});
